











































import ModalBox from "@/components/Common/Modals/ModalBox.vue";
import TablePlaceholder from "@/components/Common/Table/TablePlaceholder.vue";
import LTable from "@/components/Common/LTable.vue";
import { defaultFormatter, moment } from "@core/filters";
import { GET_CAPACITY_HISTORY } from "@core/store/action-constants";
import { useCapacityHistory } from "@/stores/admin/capacityAndBumps/capacity/capacityHistoryStore";
import { storeToRefs } from "pinia";
import { onUnmounted, watchEffect } from "@vue/composition-api";
import { useWait } from "@/stores/common/waitStore";
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const historyState = useCapacityHistory();
  const {
    isActive,
    pagination,
    data
  } = storeToRefs(historyState);
  const isLoading = useWait(historyState, GET_CAPACITY_HISTORY);
  watchEffect(() => historyState.GET_CAPACITY_HISTORY());
  onUnmounted(() => {
    historyState.$reset();
  });
  return {
    defaultFormatter,
    moment,
    isActive,
    pagination,
    data,
    isLoading
  };
};
__sfc_main.components = Object.assign({
  ModalBox,
  TablePlaceholder,
  LTable
}, __sfc_main.components);
export default __sfc_main;
